var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeenyiconsNodejsSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "teenyicons:nodejs-solid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112 33.704L60 3.35999L8 33.704V86.296L16.048 90.992L32.504 84.336C34.7185 83.4393 36.6149 81.9019 37.9503 79.9208C39.2858 77.9398 39.9995 75.6052 40 73.216V32H48V73.216C47.9994 77.1987 46.8098 81.0905 44.5835 84.3929C42.3573 87.6952 39.1957 90.2577 35.504 91.752L24.784 96.088L60 116.64L112 86.304V33.704ZM56 48C56 43.7565 57.6857 39.6869 60.6863 36.6863C63.6869 33.6857 67.7565 32 72 32H81.336C89.432 32 96 38.56 96 46.664V48H88V46.664C88 45.7889 87.8276 44.9223 87.4927 44.1138C87.1578 43.3053 86.667 42.5706 86.0482 41.9518C85.4293 41.333 84.6947 40.8422 83.8862 40.5073C83.0777 40.1724 82.2111 40 81.336 40H72C69.8783 40 67.8434 40.8428 66.3431 42.3431C64.8429 43.8434 64 45.8783 64 48C64 50.1217 64.8429 52.1566 66.3431 53.6568C67.8434 55.1571 69.8783 56 72 56H80C84.2435 56 88.3131 57.6857 91.3137 60.6863C94.3143 63.6869 96 67.7565 96 72C96 76.2435 94.3143 80.3131 91.3137 83.3137C88.3131 86.3143 84.2435 88 80 88H72C67.7565 88 63.6869 86.3143 60.6863 83.3137C57.6857 80.3131 56 76.2435 56 72H64C64 74.1217 64.8429 76.1566 66.3431 77.6568C67.8434 79.1571 69.8783 80 72 80H80C82.1217 80 84.1566 79.1571 85.6569 77.6568C87.1571 76.1566 88 74.1217 88 72C88 69.8783 87.1571 67.8434 85.6569 66.3431C84.1566 64.8428 82.1217 64 80 64H72C67.7565 64 63.6869 62.3143 60.6863 59.3137C57.6857 56.3131 56 52.2435 56 48Z",
    fill: "#FE6E00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeenyiconsNodejsSolid);
export default __webpack_public_path__ + "static/media/teenyicons-nodejs-solid.4bbd8b59be1ee1eb7f44dacc1a59716c.svg";
export { ForwardRef as ReactComponent };